import React, { useEffect, useState } from "react";
import * as api from "../../common/athleteCommon/API";
import * as func from "../../common/athleteCommon/FunctionCalls";
import { all_routes } from '../../router/all_routes';
import Utils from "../../common/athleteCommon/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import MedicalHistory from "./MedicalHistory";
import InjuryHistory from "./InjuryHistory";
import SurgeryHistory from "./SurgeryHistory";
import PhysiologicalHistory from "./PhysiologicalHistory";

const Profile = () => {

    const routes = all_routes;
    const navigate = useNavigate();
    const [oldPwd, setOldPwd] = useState('');
    const [newPwd, setNewPwd] = useState('');
    const [cnfmNwPwd, setCnfmNwPwd] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [pwdError, setPwdError] = useState('');
    const [profileDetails, setProfileDetails] = useState<any[]>([]);
    const [medicalHistory, setMedicalHistory] = useState<any[]>([]);
    const [injuryHistory, setInjuryHistory] = useState<any[]>([]);
    const [surgeryHistory, setSurgeryHistory] = useState<any[]>([]);
    const [physiologicalHistory, setPhysiologicalHistory] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("Medical History");

    const UsrName = localStorage.getItem('UserName');

    useEffect(() => {
        async function fetchDetails() {
            setIsLoading(true);
            const profileResponse = await func.athleteProfile();

            setProfileDetails(profileResponse.athleteProfile || {})
            setMedicalHistory(profileResponse.medicalHistory || {})
            setInjuryHistory(profileResponse.injuryHistory || {})
            setSurgeryHistory(profileResponse.surgeryHistory || {})
            setPhysiologicalHistory(profileResponse.physiologicalHistory || {})

            setIsLoading(false);
        }
        fetchDetails();
    }, [])

    const tabData = [
        {
            icon: <i className="fas fa-user" />,
            name: "Medical History",
            content: <MedicalHistory history={medicalHistory} />
        },
        {
            icon: <i className="fas fa-id-card" />,
            name: "Injury History",
            content: <InjuryHistory history={injuryHistory} />
        },
        {
            icon: <i className="fas fa-futbol" />,
            name: "Surgery History",
            content: <SurgeryHistory history={surgeryHistory} />
        },
        {
            icon: <i className="fas fa-futbol" />,
            name: "Physiological History",
            content: <PhysiologicalHistory history={physiologicalHistory} />
        },
    ]

    // function changePwd() {
    //     if (!pwdError) {

    //         const formData = new FormData();
    //         formData.append('oldPassword', oldPwd)
    //         formData.append('newPassword', newPwd)

    //         const changePassWord = api.TenvicChangePassword;
    //         fetch(changePassWord, {
    //             method: "POST",
    //             headers: {
    //                 "Authorization": 'Bearer ' + Utils.getAccessToken()
    //             },
    //             body: formData
    //         })
    //             .then((response) => response.json())
    //             .then((result) => {
    //                 if (result.error == false) {
    //                     Swal.fire(result.message)
    //                     setOpenModal(false)
    //                     navigate("/tenviclogin");
    //                 } else {
    //                     setPwdError(result.message)
    //                 }
    //                 if (result.error == false) {
    //                     Swal.fire({
    //                         title: 'Success',
    //                         text: result.message,
    //                         icon: 'success',
    //                         confirmButtonText: 'OK',
    //                         allowOutsideClick: false,
    //                         allowEscapeKey: false
    //                     }).then((res) => {
    //                         if (res.isConfirmed) {
    //                             // window.location.reload(); // 🔁 Reload only after OK is clicked
    //                             setOpenModal(false)
    //                             navigate(routes.tenviclogin)
    //                         }
    //                     });
    //                 } else {
    //                     setPwdError(result.message)
    //                 }
    //             })
    //     }
    // }

    const validatePasswords = (pwd, confirmPwd) => {
        if (pwd && confirmPwd && pwd !== confirmPwd) {
            setPwdError("Passwords do not match!");
        } else {
            setPwdError("");
        }
    };
    return (
        <>
            <div className="content container" style={{ maxWidth: "1380px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items">
                                <div className="col-lg-6">
                                    <h4 className="mb-40">Profile</h4>
                                </div>
                                {/* <div className="col-lg-6 text-end">
                                    <Button
                                        className="btn-secondary me-3 text-uppercase"
                                        variant="success"
                                        onClick={() => setOpenModal(true)}
                                    >
                                        <i className="fas fa-key" />&nbsp;
                                        Change Password
                                    </Button>
                                </div> */}
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset mb-2">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center" style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                                        {/* {profileDetails && Object.entries(profileDetails).length > 0 && (
                                                            Object.entries(profileDetails).map(([key, value]) => (
                                                                <div key={key} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                                                    <h4 className="me-2">{key}:</h4>
                                                                    <strong>{value ?? "N/A"}</strong>
                                                                </div>
                                                            ))
                                                        )} */}
                                                            <table>
                                                                <tr>
                                                                    <th><h4 className="text-center">Name:</h4></th>
                                                                    <td><h6>{profileDetails.athleteName}</h6></td>
                                                                    <th><h4 className="text-center">User Email:</h4></th>
                                                                    <td><h6>{profileDetails.userEmail}</h6></td>
                                                                    <th><h4 className="text-center">User Phone:</h4></th>
                                                                    <td><h6>{profileDetails.userPhone}</h6></td>
                                                                    <th><h4 className="text-center">Role Name:</h4></th>
                                                                    <td><h6>{profileDetails.roleName}</h6></td>
                                                                </tr>
                                                                <tr>
                                                                    <th><h4 className="text-center">Sport Name:</h4></th>
                                                                    <td><h6>{profileDetails.sportsName}</h6></td>
                                                                    <th><h4 className="text-center">Coach Name:</h4></th>
                                                                    <td><h6>{profileDetails.coachName}</h6></td>
                                                                    <th><h4 className="text-center">State Name:</h4></th>
                                                                    <td><h6>{profileDetails.geographyName}</h6></td>
                                                                    <th><h4 className="text-center">District Name:</h4></th>
                                                                    <td><h6>{profileDetails.geoDistrictsName}</h6></td>                                                                    
                                                                </tr>
                                                                <tr><th><h4 className="text-center">City Name:</h4></th>
                                                                    <td><h6>{profileDetails.geoCityName}</h6></td>
                                                                    <th><h4 className="text-center">Center Name:</h4></th>
                                                                    <td><h6>{profileDetails.geoCenterName}</h6></td>
                                                                    <th><h4 className="text-center">Athelete Onboard Status Name:</h4></th>
                                                                    <td><h6>{profileDetails.athleteOnboardStatusName}</h6></td>
                                                                    <th><h4 className="text-center">Status:</h4></th>
                                                                    <td><h6>{(profileDetails.userStatus == 1) ? "Active" : "Inactive"}</h6></td>
                                                                </tr>
                                                            </table>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="row align-items-center" style={{ maxHeight: "280px", overflowY: "scroll" }}>
                                                    <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                                        <div className="coach-court-list">
                                                            <ul className="nav">
                                                                {tabData.map((tab, i) => (
                                                                    <li key={i}>
                                                                        <Link
                                                                            to="#"
                                                                            className={tab.name === activeTab ? "active" : ""}
                                                                            onClick={() => setActiveTab(tab.name)}
                                                                        >
                                                                            {tab.icon} {tab.name}
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="tab-content">
                                                        {tabData
                                                            .filter(tab => tab.name === activeTab)
                                                            .map((tab, i) => (
                                                                <div key={i}>{tab.content}</div>
                                                            ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            <Modal
                show={openModal}
                size="md"
                centered
                onHide={() => setOpenModal(false)}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="text-uppercase text-center"><i className="fas fa-key" />Change Password</h4>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Current Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="crntPwd"
                            value={oldPwd}
                            onChange={(e) => setOldPwd(e.target.value)}
                            placeholder="Current Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">New Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="newPwd"
                            value={newPwd}
                            onChange={(e) => setNewPwd(e.target.value)}
                            placeholder="New Password"
                        />
                    </div>
                    <div className="col-lg-12 mb-10">
                        <label className="form-label">Confirm Password</label>
                        <input
                            type="password"
                            className="form-control"
                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                            id="cnfmPwd"
                            value={cnfmNwPwd}
                            onChange={(e) => { setCnfmNwPwd(e.target.value); validatePasswords(newPwd, e.target.value) }}
                            placeholder="Confirm Password"
                        />
                    </div>

                    {pwdError && <div className="alert alert-danger">{pwdError}</div>}

                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-primary text-uppercase"
                        variant="success"
                        // onClick={changePwd}
                        data-bs-dismiss="modal" aria-label="Close"
                    >
                        <b><i className="fas fa-save" /> Save</b>
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default Profile;